import { combineReducers } from 'redux'

import { reducer as getNumberPrivateTrainingCenter } from './getNumberPrivateTrainingCenter'
import { reducer as getProfessionalInformationData } from './getProfessionalInformationData'
import { reducer as getProfessionnalInformationEtatique } from './getProfessionnalInformationEtatique'
import { reducer as getProfessionalQualification } from './getProfessionalQualification'
import { reducer as getIdentityRegionaleEditique } from './getIdentityRegionaleEditique'
import donneesEmploi from './donneesEmploi'

export default combineReducers({
    getNumberPrivateTrainingCenter,
    getProfessionalInformationData,
    getProfessionnalInformationEtatique,
    getProfessionalQualification,
    getIdentityRegionaleEditique,
    donneesEmploi,
})
